/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Environment
 */
export interface Environment {
    /**
     * User-facing key to identify this Environment.
     * @type {string}
     * @memberof Environment
     */
    key: string;
    /**
     * The ID of the Account
     * @type {number}
     * @memberof Environment
     */
    readonly account_id?: number;
    /**
     * The ID of the Environment
     * @type {number}
     * @memberof Environment
     */
    readonly id?: number;
    /**
     * Name of the Environment.
     * @type {string}
     * @memberof Environment
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Environment
     */
    archived: boolean;
    /**
     * Integer representing the priority of the Environment. This is used for ordering in the UI.
     * @type {number}
     * @memberof Environment
     */
    priority: number;
    /**
     * The ID of the Project this Flag belongs to
     * @type {number}
     * @memberof Environment
     */
    readonly project_id: number;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof Environment
     */
    readonly revision?: number;
    /**
     * Granular permission role
     * @type {string}
     * @memberof Environment
     */
    readonly role?: string;
}

export function EnvironmentFromJSON(json: any): Environment {
    return EnvironmentFromJSONTyped(json, false);
}

export function EnvironmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Environment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'account_id': !exists(json, 'account_id') ? undefined : json['account_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'archived': json['archived'],
        'priority': json['priority'],
        'project_id': json['project_id'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
        'role': !exists(json, 'role') ? undefined : json['role'],
    };
}

export function EnvironmentToJSON(value?: Environment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'name': value.name,
        'archived': value.archived,
        'priority': value.priority,
    };
}


